import React from 'react';

import { RepeatComponent } from 'app/component/repeat-component/RepeatComponent';
import { FlexibleSkeleton } from 'app/component/skeleton/flexible/FlexibleSkeleton';
import { RowListSkeleton } from 'app/component/skeleton/row/RowListSkeleton';
import {
    useIsDesktop,
    useWindowType,
    WindowTypeName,
} from 'app/utils/useWindowType';

export const ConfirmationSkeleton = () => {
    const [windowType] = useWindowType();
    const [isDesktop] = useIsDesktop();

    return (
        <>
            <div style={{ height: isDesktop ? 40 : 48 }}>
                <FlexibleSkeleton windowType={windowType} />
            </div>
            <div
                style={{
                    marginTop: 32,
                    height: 32,
                    width: isDesktop ? '50%' : '100%',
                }}
            >
                <FlexibleSkeleton windowType={windowType} />
            </div>
            <div style={{ marginTop: 8 }}>
                <RepeatComponent numberRepetitions={4}>
                    <div style={{ marginTop: 24 }}>
                        <RowListSkeleton
                            rowCount={1}
                            windowType={WindowTypeName.MOBILE}
                        />
                    </div>
                </RepeatComponent>
            </div>
            <div
                style={{
                    marginTop: isDesktop ? 48 : 32,
                    height: 32,
                    width: isDesktop ? '50%' : '100%',
                }}
            >
                <FlexibleSkeleton windowType={windowType} />
            </div>
            <div style={{ marginTop: 24 }}>
                <RowListSkeleton
                    rowCount={1}
                    windowType={WindowTypeName.MOBILE}
                />
            </div>
            <div
                style={{
                    marginTop: isDesktop ? 48 : 24,
                    width: isDesktop ? '30%' : '100%',
                    height: isDesktop ? 32 : 72,
                }}
            >
                <FlexibleSkeleton windowType={windowType} />
            </div>
            {isDesktop && (
                <div style={{ marginTop: 24, height: 16 }}>
                    <FlexibleSkeleton windowType={windowType} />
                </div>
            )}
        </>
    );
};
